import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
if (!global.REACT_HELMET_CONTEXT) {
    global.REACT_HELMET_CONTEXT = {};
}
var GlobalHelmetProvider = function (_a) {
    var _b = _a.injectLocaleToHtml, injectLocaleToHtml = _b === void 0 ? true : _b, locale = _a.locale, children = _a.children;
    return (React.createElement(HelmetProvider, { context: global.REACT_HELMET_CONTEXT },
        injectLocaleToHtml && (React.createElement(Helmet, { htmlAttributes: {
                lang: locale,
            } })),
        children));
};
export default GlobalHelmetProvider;
//# sourceMappingURL=index.js.map